import getConfig from 'next/config';

const { useState } = require('react');
const { default: Script } = require('next/script');
const { YandexMapsProvider } = require('contexts/YandexMapsContext');

const {
	publicRuntimeConfig: { env, services }
} = getConfig();

const YANDEX_MAPS_MODE_HASH = {
	development: 'debug',
	production: 'release'
};

const searchParams = {
	lang: 'ru_RU',
	mode: YANDEX_MAPS_MODE_HASH[env],
	coordorder: 'longlat',
	apikey: services.yandex.maps.apikey
};

const yandexMapsSearchParams = new URLSearchParams(searchParams).toString();

const yandexMapsUrl = `https://api-maps.yandex.ru/2.1/?${yandexMapsSearchParams}`;

export const withYMapsContext = (Component) => (props) => {
	const [ymapsLoading, setYmapsLoading] = useState(false);
	const [ymapsError, setYmapsError] = useState(null);
	const [ymaps, setYmaps] = useState(null);
	return (
		<>
			<YandexMapsProvider
				ymaps={{ loading: ymapsLoading, ymaps, error: ymapsError }}
			>
				<Component {...props} />
			</YandexMapsProvider>
			<Script
				id="yandex-maps"
				src={yandexMapsUrl}
				async
				onLoad={() => {
					if ('ymaps' in window) {
						setYmapsLoading(true);
						window.ymaps.ready(
							() => {
								setYmaps(window.ymaps);
								setYmapsLoading(false);
							},
							(error) => {
								setYmapsError(error);
								setYmapsLoading(false);
							}
						);
					}
				}}
			/>
		</>
	);
};
